import React from 'react';
import PropTypes from 'prop-types';
import { I18n, Translate } from 'react-redux-i18n';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import CircularProgress from '@material-ui/core/CircularProgress';
import ProgressSpinner from '@peoplenet/vi-components-ui/src/Loading/ProgressSpinner';
import ResetPasswordInput from '../../resetPassword/component/ResetPasswordInput';
import { validatePassword } from '../../resetPassword/util';

export default class SetupDvrToolkitPasswordStep extends React.Component {
  constructor() {
    super();
    this.state = {
      password: '',
      passwordError: false,
      loadedPassword: '',
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (props.currentPassword !== state.loadedPassword) {
      return {
        loadedPassword: props.currentPassword,
        password: props.currentPassword,
        passwordError: false,
      };
    }

    return {};
  }

  handlePasswordChange = (password) => {
    const validation = validatePassword(password);

    this.setState({
      password,
      passwordError: validation.error,
    });
  };

  handleDefinePasswordClick = async () => {
    if (!this.canDefinePassword()) {
      return;
    }

    await this.props.actions.defineDvrToolkitPassword(
      this.props.userName,
      this.state.password,
    );
    this.props.onNextStep();
  };

  isPasswordDefined() {
    if (this.state.loadedPassword) {
      return true;
    }

    return this.props.definePassword.success;
  }

  canDefinePassword() {
    const { password, passwordError } = this.state;

    if (!password) {
      return false;
    }

    if (passwordError) {
      return false;
    }

    return !this.props.definePassword.loading;
  }

  renderUserFeedback = () => {
    const { error } = this.props.definePassword;

    if (error) {
      return (
        <div className="feedback-addin feedback-addin-failure">
          <Icon>warning</Icon>
          <Translate value="firstTimeSetup.dvrToolkitPassword.form.feedback.failure" />
        </div>
      );
    }

    return null;
  };

  render() {
    const { loading, definePassword } = this.props;
    const { password, passwordError } = this.state;

    if (loading) {
      return <ProgressSpinner />;
    }

    return (
      <>
        <Typography variant="h2" className="title__center" gutterBottom>
          <Translate value="firstTimeSetup.dvrToolkitPassword.title" />
        </Typography>

        <Typography className="title__center margin__bottom">
          <Translate value="firstTimeSetup.dvrToolkitPassword.passwordRequirements" />
        </Typography>

        <div className="firsttimesetup__field">
          <TextField
            type="text"
            label={I18n.t(
              'firstTimeSetup.dvrToolkitPassword.form.userNameInput',
            )}
            name="username"
            value={this.props.userName}
            className="settings__username-field"
            InputProps={{
              readOnly: true,
            }}
          />
        </div>

        <div className="firsttimesetup__field">
          <ResetPasswordInput
            value={password}
            error={passwordError}
            onChange={this.handlePasswordChange}
          />
        </div>

        <div className="firsttimesetup__button-cont dvrtoolkitbutton">
          <Button
            variant="contained"
            color="primary"
            className="btn btn-primary"
            disabled={!this.canDefinePassword()}
            onClick={this.handleDefinePasswordClick}
          >
            {!definePassword.loading && (
              <Translate value="firstTimeSetup.dvrToolkitPassword.form.definePasswordButton" />
            )}
            {definePassword.loading && (
              <CircularProgress
                className="loading__cirgularprogress"
                size={25}
              />
            )}
          </Button>
        </div>

        {this.renderUserFeedback()}
      </>
    );
  }
}

SetupDvrToolkitPasswordStep.propTypes = {
  loading: PropTypes.bool,
  userName: PropTypes.string,
  currentPassword: PropTypes.string,
  definePassword: PropTypes.shape({
    loading: PropTypes.bool,
    success: PropTypes.bool,
    error: PropTypes.bool,
  }),
  onNextStep: PropTypes.func,
  actions: PropTypes.shape({
    defineDvrToolkitPassword: PropTypes.func,
  }),
};

SetupDvrToolkitPasswordStep.defaultProps = {
  loading: false,
  userName: '',
  currentPassword: '',
  definePassword: {
    loading: false,
    success: false,
    error: false,
  },
  onNextStep: () => {},
  actions: {
    defineDvrToolkitPassword: () => {},
  },
};
